import {
  SampleTempType,
  type TAccession,
  TempUnit,
  type TSample,
} from "@/lib/types";
import { usesEnumTempForSampleEdit } from "./sample-temp-mode";

export type SampleTempFormValues = {
  tempType?: SampleTempType;
  temp?: number;
  tempUnits?: TempUnit;
};

export function getSampleTempDefaults(
  sample: TSample,
  packedAt: TAccession["packedAt"],
): SampleTempFormValues {
  if (!usesEnumTempForSampleEdit(sample, packedAt)) {
    return {
      temp: sample.temp != null ? Number(sample.temp) : undefined,
      tempUnits: (sample.tempUnits ?? TempUnit.C) as TempUnit,
    };
  }

  return {
    tempType: (sample.tempType ?? SampleTempType.Ambient) as SampleTempType,
  };
}

export function sampleTempFormToUpdatePayload(
  values: Pick<SampleTempFormValues, "temp" | "tempType" | "tempUnits">,
  sample: Pick<TSample, "temp" | "tempType">,
  packedAt: TAccession["packedAt"],
) {
  if (!usesEnumTempForSampleEdit(sample, packedAt)) {
    return {
      temp: values.temp ?? null,
      tempType: null,
      tempUnits: values.tempUnits ?? TempUnit.C,
    };
  }

  return {
    temp: null,
    tempType: values.tempType ?? null,
    tempUnits: null,
  };
}

export function shipperEnumTempsToPayload(
  samples: { id: number; type: SampleTempType }[],
) {
  return samples.map(({ id, type }) => ({
    id,
    temp: null,
    tempType: type,
    tempUnits: null,
  }));
}

export function shipperExplicitTempsToPayload(
  samples: { id: number; value: number; units: TempUnit }[],
) {
  return samples.map(({ id, value, units }) => ({
    id,
    temp: value,
    tempType: null,
    tempUnits: units,
  }));
}
